import api from './api-caller';
import utils from '../mixins/utils';
const { getOrganizationPublicId } = utils.methods;


export default {
  retrieveView: (viewName) => {
    let endpoint = `/wallet/views/${viewName}`;
    return api(endpoint, 'GET')
  },
  getSavingsAccountViews: () => {
    const endpoint = `/wallet/views?section=savings`
    return api(endpoint, 'GET')
  },
  getCheckingAccountViews: () => {
    const endpoint = `/wallet/views?section=checking`
    return api(endpoint, 'GET')
  },
  deleteView: (publicId) => {
    const endpoint = `/organizations/${getOrganizationPublicId()}/views/${publicId}`;
    return api(endpoint, 'DELETE');
  },
  checkIfCanBePublished: (publicId) => {
    const endpoint = `/is-publishable/data-apps/${publicId}`;
    return api(endpoint, 'GET');
  }
}
